import React from "react";
import {
  CONSOLIDATION_PROGRESS_VARIANT_CLASS,
  ConsolidationProgressDisplay,
} from "@/lib/consolidationProgressDisplay";
import { cn } from "@/lib/utils";

type ConsolidationProgressBadgeProps = {
  display: ConsolidationProgressDisplay;
  className?: string;
  size?: "sm" | "xs";
  /** When true, stacks last verified date under the progress badge (table). */
  showLastVerified?: boolean;
};

const ConsolidationProgressBadge: React.FC<ConsolidationProgressBadgeProps> = ({
  display,
  className,
  size = "sm",
  showLastVerified = true,
}) => {
  const tooltipParts = [
    display.tooltip,
    display.variant !== "missing" ? display.lastVerifiedLabel : null,
  ].filter(Boolean);

  return (
    <span className={cn("inline-flex flex-col items-start gap-0.5", className)}>
      <span
        className={cn(
          "inline-flex w-fit items-center rounded-md border font-medium whitespace-nowrap",
          size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs",
          CONSOLIDATION_PROGRESS_VARIANT_CLASS[display.variant]
        )}
        title={tooltipParts.join(". ")}
      >
        {display.label}
      </span>
      {showLastVerified &&
        display.variant !== "missing" &&
        display.lastVerifiedLabel && (
          <span className="text-xs text-muted-foreground whitespace-nowrap">
            {display.lastVerifiedLabel}
          </span>
        )}
    </span>
  );
};

export default ConsolidationProgressBadge;
